import React, { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { toast } from "react-toastify";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { ClipBoardOnTextInputTitle, Copy, Cut } from "../../../../../Utils/Constants";
import { Btn, P } from "../../../../../AbstractElements";

export default function ClipboardOnTextInput() {
  const [inputValue, setInputValue] = useState("");
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inputValue);
      setInputValue(inputValue);
    } catch (err) {
      toast.error("Failed to copy text: " + err);
    }
  };

  const handleCut = async () => {
    try {
      await navigator.clipboard.writeText(inputValue);
      setInputValue("");
    } catch (err) {
      toast.error("Failed to cut text: " + err);
    }
  };
  return (
    <Col sm={12} md={6}>
      <Card>
        <CommonCardHeader title={ClipBoardOnTextInputTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description mb-2">{"Cut/copy from text input"}</P>
            <Input type="text" placeholder="type some text to copy / cut" value={inputValue} onChange={(event) => setInputValue(event.target.value)} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard me-2" color="primary" onClick={handleCopy}>
                <i className="fa-solid fa-copy" /> {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="secondary" onClick={handleCut}>
                <i className="fa-solid fa-scissors"></i> {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
